import React from 'react';

import selectFiles from '@chenyuwang/select-files';
import { Button } from '@components/Button';
import { FormItem } from '@components/Forms/FormItem';
import { BaseInputProps, makeFormItemProps } from '@components/Forms/helpers';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';
import { useField } from 'formik';

const strings = createStrings({
  ja: {
    download: 'ダウンロード',
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  fileName: {
    ...common.middleText,
    ...common.textGray800,
    marginTop: 8,
  },
  download: {
    ...common.middleText,
    ...common.textPrimary,
    marginTop: 8,
    display: 'block',
  },
}));

export interface SingleUploadButtonProps extends BaseInputProps {
  text: React.ReactNode;
  downloadText?: React.ReactNode;
}

export const SingleUploadButton: React.FC<SingleUploadButtonProps> = (props) => {
  const { text, downloadText = strings.download, name } = props;

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const [fileField, , filehelpers] = useField<File | undefined>(`${name}.file`);
  const [remoteField] = useField<string | undefined>(`${name}.remote`);

  const onClick = async () => {
    const files = await selectFiles({
      accept: 'application/pdf',
      multiple: false,
    });

    if (files && files.length > 0) {
      const file = files[0];
      filehelpers.setValue(file);
    }
  };

  return (
    <FormItem {...makeFormItemProps(props)}>
      <div className={classes.flexColumn}>
        <Button
          text={text}
          color="primary"
          size="small"
          shape="round"
          type="button"
          onClick={onClick}
        />
        {fileField.value !== undefined && (
          <div className={classes.fileName}>
            {fileField.value.name}
            <IconButton onClick={() => filehelpers.setValue(undefined)}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </div>
        )}

        {remoteField.value && !fileField.value && (
          <a className={classes.download} href={remoteField.value} target="_blank" rel="noreferrer">
            {downloadText}
          </a>
        )}
      </div>
    </FormItem>
  );
};
